import React from 'react';
import ProjectContent from './contents/Project';
import Entreprise from './contents/Entreprise';
import Trainer from './contents/Trainer';
import Customer from './contents/Customer';
import Referent from './contents/Referent';
import Learner from './contents/Learner';
import Course from './contents/Course';
import { AlertCircle, FileText } from 'lucide-react';
import ProjectByReference from './contents/ProjectByReference';
import Folder from './contents/Folder';
import ProjectWithEtpComponent from './contents/ProjectWithEtp';
import ProjectComponent from './contents/Project';
import ProjectByCityComponent from './contents/ProjectByCity';
import ProjectByPlaceComponent from './contents/ProjectByPlace';
import ProjectByNeighborhoodComponent from './contents/ProjectByNeighborhood';
import ReferentCustomer from './contents/ReferentCustomer';


const ContentRenderer = ({ activeTab, contentData, searchQuery, getTabLabel, customerId, idEtp }) => {
    // Extract content type from active tab
    const getContentType = (tabId) => {
        if (tabId.startsWith('project_with_client-')) {
            return 'project_with_client';
        }
        return tabId;
    };

    const contentType = getContentType(activeTab);

    // Render content based on tab type
    const renderContentByType = () => {
        const createCommonProps = () => {
            const baseProps = {
                key: `${searchQuery}-${activeTab}`,
                searchKey: searchQuery,
                idCustomer: localStorage.getItem('idCustomer')
            };

            // Add idEtp for specific content types that need it
            if (contentType.startsWith('Projet avec')) {
                return {
                    ...baseProps,
                    idEtp: idEtp
                };
            }

            return baseProps;
        };

        const commonProps = createCommonProps();

        if (contentType === 'learner') {
            return <Learner {...commonProps} />;
        }
        if (contentType === 'entreprise') {
            return <Entreprise {...commonProps} />;
        }
        if (contentType === 'course') {
            return <Course {...commonProps} />;
        }
        if (contentType === 'trainer') {
            return <Trainer {...commonProps} />;
        }
        if (contentType === 'project_reference') {
            return <ProjectByReference {...commonProps} />;
        }
        if (contentType === 'project') {
            return <ProjectComponent {...commonProps} />;
        }
        if (contentType === 'projectCity') {
            return <ProjectByCityComponent {...commonProps} />;
        }
        if (contentType === 'projectPlace') {
            return <ProjectByPlaceComponent {...commonProps} />;
        }
        if (contentType === 'projectNeighborhood') {
            return <ProjectByNeighborhoodComponent {...commonProps} />;
        }
        if (contentType.startsWith('Projet avec')) {
            return <ProjectWithEtpComponent {...commonProps} />;
        }
        if (contentType === 'referent') {
            return <Referent {...commonProps} />;
        }
        if (contentType === 'referent_customer') {
            return <ReferentCustomer {...commonProps} />;
        }
        if (contentType === 'folder') {
            return <Folder {...commonProps} />;
        }

        // Cas par défaut
        return (
            <div className="py-12 text-center">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl">
                    <AlertCircle className="w-8 h-8 text-gray-500" />
                </div>
                <h3 className="mb-2 text-lg font-semibold text-gray-800">Contenu non disponible</h3>
                <p className="text-gray-600">Ce type de contenu n'est pas encore pris en charge</p>
            </div>
        );

    };

    return (
        <div className="space-y-6">
            {/* Content Header */}
            <div className="flex items-center justify-between pb-4 border-b border-gray-200">
                <div className="flex items-center gap-3">
                    <div>
                        <h2 className="text-xl font-bold text-gray-800">
                            {getTabLabel(activeTab)}
                        </h2>
                        {/* <p className="text-sm text-gray-500">
                            {contentData?.items?.length || 0} résultat(s) trouvé(s)
                        </p> */}
                    </div>
                </div>

                <div className="text-right">
                    {/* <p className="text-xs text-gray-400">
                        Dernière mise à jour
                    </p>
                    <p className="text-sm font-medium text-gray-600">
                        {new Date().toLocaleTimeString('fr-FR', {
                            hour: '2-digit',
                            minute: '2-digit'
                        })}
                    </p> */}
                </div>
            </div>

            {/* Content Body */}
            <div className="min-h-[400px]">
                {renderContentByType()}
            </div>
        </div>
    );
};

export default ContentRenderer;